export const PAGE_SIZE = 25

export const reducerSetChatPagination = (state) => {
  return {
    ...state,
    chatsPagination: state.chatsPagination + PAGE_SIZE
  }
}
